import React from "react";
import { connect } from "react-redux";

import Helmet from 'react-helmet';

import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { StylesProvider } from "@mui/styles";
import { ThemeProvider } from "styled-components";
import { MixerDataProvider } from './dataStore/mixers/MixerStore'
import { AuthProvider } from './dataStore/auth/AuthStore'
import { TourProvider } from './dataStore/mixers/TourStore'

import maTheme from "./theme";
import Routes from "./routes/Routes";

function App({ theme }) {
  return (
    <React.Fragment>
      <Helmet
        titleTemplate="%s | Sulzer"
        defaultTitle="Sulzer"
      />
      <StylesProvider injectFirst>
        <StyledEngineProvider injectFirst>
          <MuiThemeProvider theme={maTheme[theme.currentTheme]}>
            <ThemeProvider theme={maTheme[theme.currentTheme]}>
              <AuthProvider>
                <MixerDataProvider>
                  <TourProvider>
                    <Routes />
                  </TourProvider>
                </MixerDataProvider>
              </AuthProvider>
            </ThemeProvider>
          </MuiThemeProvider>
        </StyledEngineProvider>
      </StylesProvider>
    </React.Fragment>
  );
}

export default connect(store => ({ theme: store.themeReducer }))(App);
